const ComplementoDividendosRules  = {
  DividOUtil: {
    CveTipDivOUtil: [
      'required',
      'string',
      'in:01,02,03,04,05,06',
    ],
    MontISRAcredRetMexico: [
      'required',
      'decimal:6',
    ],
    MontISRAcredRetExtranjero: [
      'required',
      'decimal:6',
    ],
    MontRetExtDivExt: [
      'decimal:6',
    ],
    TipoSocDistrDiv: [
      'required',
      'string',
      'in:Sociedad Nacional,Sociedad Extranjera',
    ],
    MontISRAcredNal: [
      'decimal:6',
    ],
    MontDivAcumNal: [
      'decimal:6',
    ],
    MontDivAcumExt: [
      'decimal:6',
    ],
  },
  Remanente: {
    ProporcionRem: [
      'numeric',
      'decimal:6',
      'max:9999999999',
    ]
  }
};

export default ComplementoDividendosRules;